var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh","width":"100vw","background-size":"cover","background-repeat":"no-repeat"},style:({ backgroundImage: 'url(' + require('@/assets/background-login.jpg') + ')' })},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }